import request from '../request';
import { reportByIdLoaded } from '../../reducers/reports';
import { ReportByProject } from '../../types/apiDomain';

export default (id: number) => (dispatch) =>
    request<ReportByProject>({
        url: `/api/report/project/${id}`
    }).then((ReportById) => dispatch(reportByIdLoaded({ report: ReportById })));
